<h2>Share</h2>

<div *ngIf="accessDenied">
  <p>Sorry, you do not appear to have access to this project.</p>
  <p>Please contact Oceancaster if you believe this is in error.</p>
</div>
